<template>
  <div class="kris-documents-box" v-if="data">
    <div id="accordion1" class="panel-group">
      <div id="folders-from-ekis">
<!--        <folder v-bind:key="folder.id" v-for="folder in data.folders" :name="folder.title" :hash="folder.id" :items="folder.files" parent="0"/>-->
        <FolderV2 v-bind:key="item.id" v-for="item in dataParentDoc.folders" :info="item" :folder-name="item.name" parent="0"/>
        <ul v-if="dataParentDoc.files" class="kris-doclist ekis" style="width: 95%;">
          <FileV2 v-bind:key="item.hash" v-for="item in dataParentDoc.files" :info="item"/>
        </ul>
      </div>
    </div>
  </div>
  <div class="kris-documents-box" v-else>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FolderV2 from '../FolderV2'
import FileV2 from '../FileV2'
export default {
  name: 'parentPay',
  components: {
    'FolderV2': FolderV2,
    'FileV2': FileV2
  },
  computed: {
    ...mapState({
      'data': 'dataParentPay'
    }),

    dataParentDoc: function () {
      let $this = this
      let roots = [], i, key=0;
      let relatedFiles = []
      roots.push({"folders": [], "files": [], "name": 'root', "hash": key})
      for (i = 0; i < this.data.length; i += 1) {
        if (this.data[i].doc_location !== '') {
          let m = roots[0];
          let fs = this.data[i].doc_location.split('|')
          let item = this.data[i]
          if(item.parent_guid === '') {
            _.each(fs, function (v) {
              let folder_name = v.trim().toLowerCase()
              key++
              let k = $this.findInd(m.folders, folder_name);
              if (k === -1)
                k = m.folders.push({"folders": [], "files": [], "name": folder_name, "hash": key}) - 1
              m = m.folders[k]
            })
            m.files.push(this.data[i])
          }
        } else {
          roots[0].files.push(this.data[i])
        }
      }

      return roots[0]
    }
  },
  created () {
    this.$store.dispatch('getDataParentPay')
  },

  methods: {
    findInd(mas, name) {
      let i = -1
      _.each(mas, function (v, j) {
        if (v.name == name) {
          i = j
          return
        }
      })
      return i;
    },
  }
}
</script>

<style scoped>

</style>
